import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ClientSpendingFormValues } from '../../FirmClient/types';
import { TextArea, TextAreaProps } from '../../UI';

interface SpendingCategoryEstimateNotesTextAreaProps
  extends Omit<
    TextAreaProps,
    | 'onChange'
    | 'onBlur'
    | 'name'
    | 'status'
    | 'label'
    | 'textAreaStyles'
    | 'autosize'
  > {}

export const SpendingCategoryEstimateNotesTextArea: FC<
  SpendingCategoryEstimateNotesTextAreaProps
> = (props) => {
  const { t: tForm } = useTranslation('form');
  const {
    register,
    formState: { errors },
  } = useFormContext<ClientSpendingFormValues>();

  return (
    <TextArea
      {...props}
      {...register('notes')}
      autosize
      minRows={3}
      status={errors.notes ? 'errored' : 'normal'}
      label={tForm('spending-category-estimate-notes-textarea-label')}
    />
  );
};
